export const data = [
  {
    sectionTitle: "About my Yoga Pack",
    questionsList: [
      {
        questionText: "What does my Yoga pack include?",
        type: "type1",
        headerText: ["Your Yoga pack will include:"],
        footerText: ["* Subject to availability"],
        bulletPoints: [
          "Access to UNLIMITED live classes",
          "Flexibility to personalize your schedule (choose a day & time that suits you) *",
          "Structured goal based classes",
          "Guidance from our Yoga trainers",
        ],
      },
      {
        questionText: "Where can I see the start & end date of my pack?",
        type: "type1",
        headerText: [
          `Soon after you book a pack, you will receive an email with these dates.
        You can also check the dates on the Shyft App in the ‘My Classes’ section under ‘Active Packs’.`,
        ],
      },

      {
        questionText: "Can I pause my Yoga pack?",
        type: "type1",
        headerText: [
          `We currently don't offer the option to pause a pack. But, you get unlimited classes with each pack, so you can personalize your Yoga routine to suit your schedule!`,
        ],
      },

      {
        questionText: " Can I get a refund for my pack?",
        type: "type1",
        headerText: [
          `Since we curate small batches of classes, tailored to your needs, we do not offer refunds on plans at this time.`,
          `If you have any questions or concerns please feel free to reach out to us via the 'Help' section on the App.`,
        ],
      },
    ],
  },

  {
    sectionTitle: " Setting up my 'Yoga routine'",
    questionsList: [
      {
        questionText: "What is a 'Shyft Yoga routine'?",
        type: "type1",
        headerText: [
          `At Shyft, we want our customers to have a smooth & pleasant experience. To ensure this, we've designed a 'Shyft Yoga routine' which is a simple, yet effective way to help you get the most out of our Yoga packs.`,
          `A 'Shyft Yoga routine' comprises the days and times of the week when you want to exercise & attend our live classes. Once you choose a routine ( i.e. your preferred slots for the week) we will pre-book all your classes till the end of the pack.`,
          `This helps you remain consistent and keeps the booking process hassle-free!`,
        ],
      },

      {
        questionText: "How can I set my 'Shyft Yoga routine'?",
        type: "type1",
        headerText: ["It's super simple. Just follow these steps:"],
        footerText: [
          "* You can view your routine details under 'Classes' by clicking on Active Packs",
        ],
        bulletPoints: [
          "Click on the 'Classes' section on the Home screen of the app",
          "Click on 'Setup your weekly routine'",
          "Select the days",
          "Select the time",
          "Confirm your selection",
        ],
      },

      {
        questionText: "Can I attend classes outside of my routine?",
        type: "type1",
        headerText: [
          `Yes, you can. You will find more information on this in the 'Booking real-time classes' section below.`,
        ],
      },

      {
        questionText: "How often should I attend classes in a course?",
        type: "type1",
        headerText: [
          `We recommend you attend 3 classes per week. This also takes into account the recovery days which are an important part of a healthy workout.`,
        ],
      },

      {
        questionText: "How many classes can I book in my routine?",
        type: "type1",
        headerText: [
          `You can book one class each day. So, up to 7 classes per week.`,
        ],
      },
    ],
  },

  {
    sectionTitle: "Attending a class outside my set routine",
    questionsList: [
      {
        questionText: "How do I book a real-time class?",
        type: "type1",
        headerText: [
          `Booking your class is super easy via the App. Book a class up to 5 mins before the start time by following the steps below:`,
        ],
        bulletPoints: [
          "Click on the Classes section on the Home screen of the app",
          "Click on the 'Book your class' card",
          "Select the day",
          "Choose a class and click 'Book',",
        ],
      },

      {
        questionText: "How many days in advance can I book a class?",
        type: "type1",
        headerText: ["You can book the classes up to 7 days in advance."],
      },

      {
        questionText: "How many classes can I book at a time?",
        type: "type1",
        headerText: [`There is no limit. You can book any class.`],
      },

      {
        questionText: "Can I cancel my class?",
        type: "type1",
        headerText: [
          `Yes! You can cancel a booked class up to 15 minutes before the class begins.To cancel classes within the next 24 hours, click on the 'Cancel' button in the upcoming class section`,
          `To cancel classes that will take place after the next 24 hours, follow these simple steps:`,
        ],
        bulletPoints: [
          "Click on the 'Classes' section",
          "Click 'Book Your Classes'",
          "Scroll to the class.",
          "Click on 'Cancel'",
        ],
      },

      {
        questionText: "My desired slots are always booked.",
        type: "type1",
        headerText: [
          `We understand your disappointment when this happens. You can book classes up to 7 days in advance.`,
          `Our suggestion is to plan your classes and set up your routine to avoid missing out on preferred time slots.`,
          `At times, you will also see slots open up about 30 minutes before a class. Do keep an eye out for these as they get booked quickly.`,
        ],
      },

      {
        questionText: "Can I choose a different trainer?",
        type: "type1",
        headerText: [
          `Yes, you can. Although we recommend that you work with the same trainer for consistency, this is completely your choice!`,
        ],
      },
    ],
  },

  //   ##############

  {
    sectionTitle: "Attending Shyft Yoga Classes Online",
    questionsList: [
      {
        questionText: "What do I need for an online class?",
        type: "type1",
        headerText: [
          `We want you to have an effortless and smooth Yoga experience at Shyft.`,
          `Here are a few recommendations to get the best out of each session:`,
        ],
        bulletPoints: [
          "Use a laptop, tablet, or mobile phone to attend the session online. If you anticipate background noise, consider using headphones during the class",
          "Bring a yoga mat, a towel, and a bottle of water",
          "Practice in a space where you can lay the mat on the floor comfortably, and move around the mat freely",
          "Find a space where you're unlikely to be disturbed",
          "It's usually better to keep your mic on mute during a class. If you have questions, you can join the class 10 mins early. Trainers are always available for a chat before the session.",
          "Don't forget to keep your video on for the duration of the class. This helps your trainer to guide your practice, and where needed, correct your posture",
        ],
      },

      {
        questionText: "What should I wear to a class?",
        type: "type1",
        headerText: [
          "We suggest that you wear something comfortable. Any outfit that lets you move freely and stretch your body during the session.",
        ],
      },

      {
        questionText: "How do I join my Yoga class?",
        type: "type2",
        headerText: [
          `You can join classes via the App or the website. The link will appear 24 hours before the class start time.`,
        ],
        sectionData: [
          {
            sectionHeading: "<span>On the App</span>",
            bulletPoints: [
              "You will see the join button in the upcoming section on the home screen.",
              "You will see the join button in the upcoming section in 'Classes'.",
            ],
          },

          {
            sectionHeading: "<span>On the Web</span>",
            bulletPoints: [
              "You will see the join button in your 'Profile' section",
            ],
          },
        ],
      },

      {
        questionText: "How early can I join my class?",
        type: "type1",
        headerText: [
          `You can join your class 10 mins before the start time. The trainer is always available 10 minutes before the class to answer any questions you might have. You can clarify any doubts & discuss concerns during this time.`,
        ],
      },

      {
        questionText: "I will be late for my class. What's going to happen?",
        type: "type1",
        headerText: [
          `There's no need to stress. As long as you can make it within 10 mins of the start time, you will be able to join.`,
          `It's usually best to avoid joining a class late as you will miss out on the warm-up exercises which are a crucial part of the session.`,
          `We also like to be mindful of other users who might feel disturbed by late joiners.`,
          `In case you are unable to join a class, you can always book another class within your pack.`,
        ],
      },

      {
        questionText: "I was logged out. How can I rejoin my class?",
        type: "type2",
        headerText: [
          `In case you get logged out for any reason, you can join back by using the rejoin button on either the website or the App`,
        ],

        sectionData: [
          {
            sectionHeading:
              "<span>On the App, you will see the rejoin button</span>",
            bulletPoints: [
              "Under the 'Upcoming' section on the home screen",
              "Under the 'Upcoming' section in 'Classes'",
            ],
          },

          {
            sectionHeading: "<span>On the Web</span>",
            bulletPoints: [
              "You will see the rejoin button in your Profile section",
            ],
          },
        ],
      },

      {
        questionText: "Will I get reminders about my classes?",
        type: "type1",
        headerText: [
          `Yes, you will be notified about your class through an App notification.`,
        ],
        bulletPoints: [
          "24 hours before the class starts",
          "90 mins before the class starts",
        ],
      },

      {
        questionText: "I am unable to join my class",
        type: "type1",
        headerText: [
          `You don't need to worry! Please reach out to us via the ‘Chat with Support’ section, which you can find at the bottom of this page. Our team will ensure a quick resolution.`,
        ],
      },
    ],
  },

  {
    sectionTitle: "Others",
    questionsList: [
      {
        questionText:
          "I love Shyft classes. Can I refer my family and friends?",
        type: "type1",
        headerText: [
          `Firstly, thank you! We're thrilled to know you're benefiting from Shyft's classes.
        We would love it if you could refer your friends and family to us.
        As a reward, you'll get two additional weeks of classes for every successful referral!`,
        ],
        footerText: [
          "<span>Note: A successful referral is one where your loved one has paid for their pack.</span>",
        ],
      },
    ],
  },
];
